import { render, staticRenderFns } from "./Channel.vue?vue&type=template&id=7638a336&scoped=true&"
import script from "./Channel.vue?vue&type=script&lang=js&"
export * from "./Channel.vue?vue&type=script&lang=js&"
import style0 from "./Channel.vue?vue&type=style&index=0&id=7638a336&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7638a336",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7638a336')) {
      api.createRecord('7638a336', component.options)
    } else {
      api.reload('7638a336', component.options)
    }
    module.hot.accept("./Channel.vue?vue&type=template&id=7638a336&scoped=true&", function () {
      api.rerender('7638a336', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/settings/Channel.vue"
export default component.exports